import React from 'react';
import { t } from '@citrite/translate';
import { Tooltip } from '@citrite/web-ui-component';
import { DetailedDesktopTile } from 'App/Tile/DetailedDesktopTile';
import {
	isResourceAvailable as checkResourceAvailability,
	Resource,
} from 'Workspace/ResourceProvider/resourceTypes';

interface Props {
	resource: Resource;
}

export function DetailedDesktopTileRender({ resource }: Props) {
	const isResourceAvailable = checkResourceAvailability(resource);

	const detailedDesktopTile = (
		<DetailedDesktopTile resource={resource} isResourceAvailable={isResourceAvailable} />
	);

	return isResourceAvailable ? (
		detailedDesktopTile
	) : (
		<Tooltip hoverTrigger={detailedDesktopTile} isDisabled={isResourceAvailable}>
			{t('Workspace:apps_or_desktop_unavailable_shield')}
		</Tooltip>
	);
}
